"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaControl = void 0;
var react_1 = __importDefault(require("react"));
var TextAreaControl = function (props) {
    var label = props.label, value = props.value, onChange = props.onChange, _a = props.lines, lines = _a === void 0 ? 5 : _a;
    return (react_1.default.createElement("div", { className: "flex flex-col gap-1" },
        label && react_1.default.createElement("label", { className: "text-md font-bold text-black" }, label),
        react_1.default.createElement("textarea", { value: value, onChange: function (e) {
                if (onChange) {
                    onChange(e.target.value);
                }
            }, rows: lines, className: "p-2 \n          border border-black\n          rounded-lg shadow-sm resize-none outline-none \n          focus:ring-2 focus:ring-indigo-400\n        " })));
};
exports.TextAreaControl = TextAreaControl;
